import { Component, input } from '@angular/core';
import { CardComponent } from '@sportello-balneari/shared-components';
import { IncoherenceReport } from '../../../../../api/interfaces';

@Component({
  selector: 'lib-result-incoherence-report-card',
  standalone: true,
  imports: [CardComponent],
  templateUrl: './incoherence-report-card.component.html',
})
export class ResultIncoherenceReportCardComponent {
  incoherenceReport = input<IncoherenceReport | null | undefined>();
}
